import React, { useState } from 'react';
import SimpleDateSelector from '../../selectors/date/SimpleDateSelector';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

const NEW_TRANSACTION_DATE = 'NewTransactionDate';
const ReschedulePanel = (props) => {

    const [newTransactionDate, setNewTransactionDate] = useState(undefined);

    const selectionHandler = (date) => {
        setNewTransactionDate(date.NewTransactionDate);
    };

    const onYesClick = () => {
        props.onSubmit(newTransactionDate);
    };

    const onCancelClick = () => {
        props.onClose();
    };

    return (
        <div className='mt15'>
            <h2 className="header-spacing"><LanguageStringResolver string={props.title}/></h2>
            <fieldset className='half-width mt10' data-testid="date-selector">
                <label><LanguageStringResolver string='reschedule_header'/></label>
                <SimpleDateSelector
                    selectionHandler={selectionHandler}
                    fieldName={NEW_TRANSACTION_DATE}
                />
            </fieldset>
            <hr className="mt40 mb20" />
            <button className="primary" data-testid="submit-button" onClick={onYesClick} disabled= {newTransactionDate === undefined}><LanguageStringResolver string='reschedule_Ok'/></button>
            <button className="secondary" data-testid="cancel-button" onClick={onCancelClick} ><LanguageStringResolver string='reschedule_Cancel'/></button>
        </div>
    );
};

export default ReschedulePanel;